import { render, staticRenderFns } from "./MailingAddress.vue?vue&type=template&id=047ca5bb&scoped=true&"
import script from "./MailingAddress.vue?vue&type=script&lang=js&"
export * from "./MailingAddress.vue?vue&type=script&lang=js&"
import style0 from "./MailingAddress.vue?vue&type=style&index=0&id=047ca5bb&lang=scss&scoped=true&"
import style1 from "./MailingAddress.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047ca5bb",
  null
  
)

export default component.exports